import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { clamp } from '../../../utils/clamp.mjs';
var number = {
  test: function test(v) {
    return typeof v === "number";
  },
  parse: parseFloat,
  transform: function transform(v) {
    return v;
  }
};
var alpha = _objectSpread(_objectSpread({}, number), {}, {
  transform: function transform(v) {
    return clamp(0, 1, v);
  }
});
var scale = _objectSpread(_objectSpread({}, number), {}, {
  default: 1
});
export { alpha, number, scale };